import AssignmentType from "./actionTypes"

const INIT_STATE = {
  staffListTrouser: {
    loading: true,
    data: [],
  },
  staffListJacket: {
    loading: true,
    data: [],
  },
  rtwOrder: {
    loading: true,
    data: [],
  },
  rtwOrderSize: {
    loading: true,
    data: [],
  },
  order: {
    loading: true,
    data: [],
  },
  weekList: {
    loading: true,
    data: [],
  },
  putRtwOrder: {
    loading: false,
  },
  putOrder: {
    loading: false,
  },
  deleteRtwOrder: {
    loading: false,
  },
  deleteOrder: {
    loading: false,
  },
  patchData: {
    loading: false,
  },
}

const Assignment = (state = INIT_STATE, action) => {
  switch (action.type) {
    case AssignmentType.GET_ASSIGNMENT_STAFF_TROUSER_LIST_SUCCESS:
      return {
        ...state,
        staffListTrouser: action.payload,
      }

    case AssignmentType.GET_ASSIGNMENT_STAFF_JACKET_LIST_SUCCESS:
      return {
        ...state,
        staffListJacket: action.payload,
      }

    case AssignmentType.GET_ASSIGNMENT_RTW_ORDER_LIST_SUCCESS:
      return {
        ...state,
        rtwOrder: action.payload,
      }

    case AssignmentType.GET_ASSIGNMENT_RTW_ORDER_SIZE_LIST_SUCCESS:
      return {
        ...state,
        rtwOrderSize: action.payload,
      }

    case AssignmentType.GET_ASSIGNMENT_ORDER_LIST_SUCCESS:
      return {
        ...state,
        order: action.payload,
      }

    case AssignmentType.GET_ASSIGNMENT_WEEK_LIST_SUCCESS:
      return {
        ...state,
        weekList: action.payload,
      }

    case AssignmentType.PUT_ASSIGNMENT_RTW_ORDER_SUCCESS:
      return {
        ...state,
        putRtwOrder: action.payload,
      }
    case AssignmentType.PUT_ASSIGNMENT_ORDER_SUCCESS:
      return {
        ...state,
        putOrder: action.payload,
      }
    case AssignmentType.DELETE_ASSIGNMENT_RTW_ORDER_SUCCESS:
      return {
        ...state,
        deleteRtwOrder: action.payload,
      }
    case AssignmentType.DELETE_ASSIGNMENT_ORDER_SUCCESS:
      return {
        ...state,
        deleteOrder: action.payload,
      }

    case AssignmentType.PATCH_ASSIGNMENT_DATA_SUCCESS:
      return {
        ...state,
        patchData: action.payload,
      }

    case AssignmentType.PUT_ASSIGNMENT_ORDER_LOCAL_STATE_SUCCESS:
      const tempOrder = [...state.order.data]

      for (const element of tempOrder) {
        if (element.id === action.payload.data.id) {
          element.finisher = action.payload.data.finisher
          element.assignedAlready = action.payload.data.assignedAlready
          element.bastingPicName = action.payload.data.bastingPicName
          element.bastingPicId = action.payload.data.bastingPicId
          element.basting = action.payload.data.basting
          element.finishedBasting = action.payload.data.finishedBasting
        }
      }

      return {
        ...state,
        order: { data: tempOrder, loading: false },
      }

    case AssignmentType.PUT_ASSIGNMENT_RTW_ORDER_LOCAL_STATE_SUCCESS:
      const tempRtwOrder = [...state.rtwOrder.data]

      for (const element of tempRtwOrder) {
        if (element.id === action.payload.data.id) {
          element.finisher = action.payload.data.finisher
          element.assignedAlready = action.payload.data.assignedAlready
        }
      }

      return {
        ...state,
        rtwOrder: { data: tempRtwOrder, loading: false },
      }

    default:
      return state
  }
}

export default Assignment
